import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";
import "../../styles/employeeDetails.css"; // Ensure file name matches

const Testimonials = () => {
  const testimonialsData = [
    {
      id: 1,
      text: "I saved 2 years by completing my B.Com along with CMA Inter. Now I’m working in an MNC.",
      name: "Priya S",
      rating: 5,
    },
    {
      id: 2,
      text: "The best decision I made for my career – degree + CA Foundation in the same time.",
      name: "Rahul K",
      rating: 5,
    },
  
  ];

  const renderStars = (count) => {
    return Array(count)
      .fill(0)
      .map((_, i) => <span key={i} className="star">★</span>);
  };

  return (
    <section className="testimonials-section">
      <div className="container">
        <Swiper
          spaceBetween={40} // Increased gap
          slidesPerView={1}
          loop={true}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          breakpoints={{
            // Mobile: 1 Slide
            0: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            // Tablet & Desktop: 2 Slides (Matches Image)
            768: {
              slidesPerView: 2,
              spaceBetween: 40,
            },
          }}
          modules={[Autoplay, Pagination]}
          className="testimonials-swiper pb-5"
        >
          {testimonialsData.map((item) => (
            <SwiperSlide key={item.id}>
              <div className="testimonial-card-wrapper">
                
                {/* 1. Grey Quote Box */}
                <div className="quote-box">
                  <p className="quote-text">{item.text}</p>
                  
                  {/* Floating User Icon */}
                  <div className="profile-wrapper">
                    <div className="profile-circle">
                      <i className="bi bi-person-fill profile-icon"></i>
                    </div>
                  </div>
                </div>

                {/* 2. Stars & Name */}
                <div className="student-info">
                  <div className="rating-stars">
                    {renderStars(item.rating)}
                  </div>
                  <h4 className="student-name">{item.name}</h4>
                </div>

              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>  
  );
};

export default Testimonials;